var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 .63l1.41 1.42-5 4.95 4.95 5L12 13.36 7 8.41l-4.95 4.95L.63 12l4.96-5-5-4.95L2.05.63l5 5z",
    fill: "#444"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNCAxNCIgZmlsbD0iIzAwNGE4NSI+CiAgICA8cGF0aCBkPSJNMTIgLjYzbDEuNDEgMS40Mi01IDQuOTUgNC45NSA1TDEyIDEzLjM2IDcgOC40MWwtNC45NSA0Ljk1TC42MyAxMmw0Ljk2LTUtNS00Ljk1TDIuMDUuNjNsNSA1eiIgZmlsbD0iIzAwNGE4NSIgLz4KPC9zdmc+Cg==";
export { SvgClose as ReactComponent };